import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./NotFound.css";
import Found from "./assets/not-found.png";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Helmet>
        <title>404 Not Found | Attoli</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <img
        src={Found}
        alt="Cartoon of a boy rummaging through a pile of papers, with stacked books on either of the paper pile with a pruple background"
        className="not-found-image"
      />

      <h1 className="not-found-title">404 — Page Not Found</h1>
      <p className="not-found-text">
        Now where did that page go? The link you followed may be broken... or
        the page.
      </p>

      <div>
        <Link to="/" className="not-found-btn not-found-link-btn">
          Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
